import { userActionsTypes } from './userActionTypes';

const { ACCESS_LIST, TIME_INTERVALS, ALERTS_COUNT } = userActionsTypes;

export const accesslist = (accesslist) => {
	return {
		type: ACCESS_LIST,
		payload: accesslist,
	};
};

export const timeTnterval = (timeTnterval) => {
	return {
		type: TIME_INTERVALS,
		payload: timeTnterval,
	};
};

export const alertsCount = (count) => {
	return {
		type: ALERTS_COUNT,
		payload: count,
	};
};
